// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"196":"dcffcd8f","693":"cf81d168"}[chunkId] + ".chunk.js";
};